module.exports = __webpack_public_path__ + "static/media/usericon.e14d20db.svg";